<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'template.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Profile <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                     </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-toggle label="Par défaut" v-model="resource.is_default"></form-toggle>

                                <form-text label="Name" v-model="resource.name" :required="true"></form-text>
                                <form-text label="Description" v-model="resource.description"></form-text>

                              </fieldset>

                              <fieldset>
                                <h3>Template de la facture</h3>
                                <p class="headline"></p>

                                <form-file label='Facture template' v-model="resource.picture_id" width="200"></form-file>

                                <form-select label="Font type" multiple="false" v-model="resource.invoice_font" :default="resource.invoice_font" :options="fonts"></form-select>

                                <form-text label="Facture ville" v-model="resource.invoice_city"></form-text>

                                <form-textarea label="Facture info" v-model="resource.invoice_info"></form-textarea>

                                <group-line-4>
                                  <form-text label="Marge (top)" v-model="resource.invoice_margin_top" suffix="mm"></form-text>
                                  <form-text label="Marge (left)" v-model="resource.invoice_margin_left" suffix="mm"></form-text>
                                  <form-text label="Marge (right)" v-model="resource.invoice_margin_right" suffix="mm"></form-text>
                                  <form-text label="Marge (bottom)" v-model="resource.invoice_margin_bottom" suffix="mm"></form-text>
                                </group-line-4>

                                <hr>

                                <h3>Champs visibles</h3>
                                <p class="headline"></p>


                                <form-toggle label="Show TVA" v-model="resource.invoice_field_vat"></form-toggle>
                                <form-toggle label="Show quantity" v-model="resource.invoice_field_qty"></form-toggle>
                                <form-toggle label="Show SKU/EAN" v-model="resource.invoice_field_sku"></form-toggle>
                                <form-toggle label="Show product title" v-model="resource.invoice_field_product_title"></form-toggle>
                                <form-toggle label="Show product headline" v-model="resource.invoice_field_product_headline"></form-toggle>
                                <form-toggle label="Show product picture" v-model="resource.invoice_field_product_picture"></form-toggle>
                                <form-toggle label="Show customer id" v-model="resource.invoice_field_customer_identifier"></form-toggle>
                                <form-toggle label="Show payment method" v-model="resource.invoice_field_payment_method"></form-toggle>
                                <form-toggle label="Show payment condition" v-model="resource.invoice_field_payment_condition"></form-toggle>
                                <form-toggle label="Show 'paid' status" v-model="resource.invoice_field_status_paid"></form-toggle>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import InvoiceTemplateService from './InvoiceTemplateService.js';
    import Edit from '../../../layouts/Edit.vue';
    import ComponentConditions from "../../../components/Conditions.vue";


    export default {
        extends: Edit,
        components: {
            'component-conditions': ComponentConditions
        },
        data () {
            return {
                resource: {
                },
                margin: 25,
                isLoading: false,
                fonts: [
                  {id:'CourierNew', name:'CourierNew'},
                  {id:'OpenSans', name:'OpenSans'},
                  {id:'RobotoCondensed', name:'RobotoCondensed'},
                  {id:'ProximaNova', name:'ProximaNova'},
                  {id:'PTSerif', name:'PTSerif'},
                  {id:'Quicksand', name:'Quicksand'}
                ],
            }
        },
        mounted: function(){
          this.option_datas = {}
          this.option_datas.payment_conditions = this.$store.getters.scope.payment_conditions;
          this.option_datas.countries = this.$store.state.countries;
        },
        methods:{
            selectType: function(bool)
            {
              this.resource.is_qr_iban = bool;
              this.$forceUpdate()
            },
            resourceLoaded: function(){
                this.setTranslations(['name','headline','description','customer_order_success','administrator_order_success']);
                this.resource.config = this.resource.config;
                this.resource.conditions = this.resource.conditions||[];
                this.variables = []
                for (var key in (this.resource.config)) {
                    if (this.resource.config.hasOwnProperty(key)) {
                        this.variables.push({id:key, value:this.resource.config[key]});
                    }
                }

                this.resource.invoice_margin_top = this.resource.invoice_margin_top >= 0 ? this.resource.invoice_margin_top : 25
                this.resource.invoice_margin_bottom = this.resource.invoice_margin_bottom >= 0 ? this.resource.invoice_margin_bottom : 25
                this.resource.invoice_margin_left = this.resource.invoice_margin_left >= 0 ? this.resource.invoice_margin_left : 25
                this.resource.invoice_margin_right = this.resource.invoice_margin_right >= 0 ? this.resource.invoice_margin_right : 25

                this.initialize()
            },
            beforeUpdate: function(Resource){
                this.updateVars();
                return true;
            },
            updateVars: function(){
                let obj = {};
                for (var i=0 ; i<this.variables.length ; i++) {
                    obj[this.variables[i].id] = this.variables[i].value;
                }
                this.resource.config = obj;
            },
            addVar: function(){
                let id = prompt('Variable name ?');
                this.variables.push({id:id,value:""});
                this.updateVars();
            },
            deleteVar: function(id){
                let index = null;
                for (var i=0 ; i<this.variables.length ; i++) {
                    if (this.variables[i].id == id) {
                        index = i;
                        break;
                    }
                }
                if( index != null ){ this.variables.splice(index,1); }
                this.updateVars();
            },
            getResource: function(){
                return InvoiceTemplateService
            },
            limitText (count) {
                return `and ${count} other countries`
            },
            asyncFind (query) {
                this.isLoading = true
                InvoiceTemplateService.query('?query=' + query ).then(response => {
                    this.companies = response.data.data
                    this.isLoading = false
                })
            },
            clearAll () {
                this.resource.companies = []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/invoice-template/Edit.vue